import type { Tk } from "../i18n";

declare module "vanilla-cookieconsent" {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Service {
    [SERVICE_LABEL_TK]: Tk;
  }
}

const SERVICE_LABEL_TK = Symbol();

export { SERVICE_LABEL_TK };
